<script>
export default {
  name: 'TotalBlockItem',
  props: {
    label: String,
    content: {
      type: String,
      required: false,
      default: null
    }
  }
}
</script>

<template>
  <div class="flex align-end gap-xs">
    <div v-if="label" class="label">{{ label }}</div>
    <div class="content text-left">
      <slot v-if="$slots.default" name="default" />
      <div v-else>{{ content || '' }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.label {
  color: var(--color-text-3);
  font-size: 12px;
  white-space: nowrap;

  &::after {
    content: '：';
  }
}
.content {
  white-space: nowrap;
  min-width: 100px;
}
</style>